import { IonButton, IonCheckbox, IonIcon, IonItem } from '@ionic/react';
import { checkmarkCircle, checkmarkCircleOutline } from 'ionicons/icons';
import React from 'react';
import Basket from '../../lib/basket';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../common';
import BlockSeparator from '../blockSeparator';

const { formatPrice } = Basket;

export const SubscriptionLine = (
  __,
  clickHandler,
  key,
  isChecked,
  name,
  description,
  price,
  perks,
) => (
  <>
    <div className="box-content" key={key}>
      <Subtitle >{__(name)}</Subtitle>
      <Spacer size={0} />
      <NormalText className="block">{__(description)}</NormalText>
      <Spacer size={2} />
      {perks && perks.length > 0 &&
        <>
          <div className="subscription-perks">
            {perks && perks.map((el) => {
              return (
                <div>
                  <IonIcon icon={checkmarkCircle} color="primary" />
                  <NormalText>{__(el.name)}</NormalText>
                </div>
              );
            })}
          </div>
          <Spacer size={2} />
        </>
      }
      <BlockSeparator fullWidth />
      <Spacer size={2} />

      <StrongText className=" block">{`${formatPrice(price, true)} ${__('per month')}`}</StrongText>
      <Spacer size={0}/>
      <SmallText className=" block">{__('Cancel at any time')}</SmallText>

      <Spacer size={2} />
      <IonButton onClick={clickHandler} expand="block" color="primary">
        {__('Select this package')}
      </IonButton>
    </div>
    <Spacer size={2} />
  </>
);
